import React from 'react'

export default function LogsInnerStyle(props) {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* Modify Parent Style Content Inner */
        #content { background-color: whitesmoke; }

        .report-wrapper { border: solid 0.5px lightgrey; }

        .logs-report-container {
          font-size: 1rem;
          background-color: white;
          box-sizing: border-box;
          padding: 25px;
        }

        .logs-report-wrapper {
          flex: 1;
          width: 100%;
        }

        .logs-table { width: 100%; }
        .logs-table th:nth-child(1), .logs-table td:nth-child(1) { width: 30%; }
        .logs-table th:nth-child(2), .logs-table td:nth-child(2) { width: 40%; }
        .logs-table th:nth-child(3), .logs-table td:nth-child(3) { width: 30%; }
        .logs-table .sortable-header { padding: 5px; }
        .logs-table .sortable-header:hover { background-color: #D2D6F7; }
        .logs-table th { padding: 10px 0; }

        .dates-header-container { display: flex; }
        .dates-header-container .date-left { flex: 1; }
        .dates-header-container .date-right {
          flex: 1;
          text-align: right;
        }

      `}
      </style>
    </React.Fragment>
  )
}
